import { useEffect, useState } from 'react'
import type { PlanEntitlements } from './plan-entitlements'
import { sdkErrorMessage, useAuthServiceClient } from './sdk-client'

// The SDK types planEntitlements as optional any, so cast to the schema-derived shape.
export interface PermissionSetEntitlements {
  planEntitlements: PlanEntitlements
  featureEntitlements: Array<{ feature: string; value?: unknown }>
}

export type PermissionSetEntitlementsState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'error'; message: string }
  | { status: 'ready'; data: PermissionSetEntitlements }

export function usePermissionSetEntitlements(key: string | null): PermissionSetEntitlementsState {
  const getClient = useAuthServiceClient()
  const [state, setState] = useState<PermissionSetEntitlementsState>({ status: key ? 'loading' : 'idle' })

  useEffect(() => {
    if (!key) {
      setState({ status: 'idle' })
      return
    }
    let cancelled = false
    setState({ status: 'loading' })

    getClient()
      .then((client) => client.auth.getPermissionSetEntitlements(key))
      .then((response) => {
        if (!cancelled) {
          setState({ status: 'ready', data: response.data as unknown as PermissionSetEntitlements })
        }
      })
      .catch((error: unknown) => {
        if (!cancelled) {
          setState({ status: 'error', message: sdkErrorMessage(error, 'Failed to load entitlements') })
        }
      })

    return () => {
      cancelled = true
    }
  }, [getClient, key])

  return state
}
